<div class="grid">
  <div *ngFor="let chart of charts" class="chart-card">
    <h3>{{ chart.title }}</h3>
    <div echarts [options]="chart.options" class="chart"></div>
  </div>
</div>
